module.exports = __webpack_public_path__ + "static/media/weather-app.9506d99c.png";